import React, { useEffect, useState, useCallback, useRef } from "react";
import { Card, Col, Row, Spinner, ProgressBar, Alert } from "react-bootstrap";
import Filtros from "./components/Filtros";
import { paginadoRecorridosStore } from '../../../lib/store/paginador_store';
import dayjs from "dayjs";
import { filter } from "underscore";
import Temperatura from "./components/temperatura_graficas/Temperatura.js";
import { GoogleMapsProvider } from "../../../providers/GoogleMapsProvider.js";
import {
    ProgressBarWithRealTimeMetrics,
    EmptyState,
    WelcomeEmptyState,
    LoadingEmptyState,
    NoDataEmptyState,
    NoSelectionEmptyState,
    ProgressBarWithComponents,
    AlertError,
    APIError,
    ValidationError
} from '../../../components/common/progressemptystate.js';
import { useRecorridosStore } from '../../../lib/store/recorridos.store'
import { useFiltrosStore } from "../../../lib/store/filtros.store";
import {
    calcularResumenUnidad,
    calcularEstadiasMultiples,
    procesarRecorridos,
    asignarVelocidadMaxima,
    normalizarFiltros, filtrarPorEventosMotor, debugFiltrarEventosMotor // ✅ IMPORTAR NUEVA FUNCIÓN
} from '../../../utils/useReporteCalculations';
import PrintReportModule from '../../../components/print/PrintReportModule';
import withReactContent from 'sweetalert2-react-content';
import Swal from 'sweetalert2';
import { cargarPaginasUltraOptimizado } from '../../../providers/provider_paginado';
import SmartComponentRenderer from '../../../components/loading/SmartComponentRenderer';
import AnimatedComponentWrapper from '../../../components/loading/AnimatedComponentWrapper';
import RecorridosTableList from "./components/recorridos-lista-quro/RecorridosTableList";

export default function TemperaturaReport() {
    const [showFilters, setShowFilters] = useState(false);
    const [recorridos, setRecorridos] = useState([]);
    const [estadias, setEstadias] = useState([]);
    const [resumenUnidad, setResumenUnidad] = useState([]);
    const [geocercas, setGeocercas] = useState([]);
    const [referencias, setReferencias] = useState([]);
    const [clientes, setClientes] = useState([]);

    const [totalCarga, setTotalCarga] = useState([]);
    const [filtrosLocal, setFiltrosLocal] = useState(null);

    const paginadorRecorridos = paginadoRecorridosStore();

    // Controla estado de filter
    const [isLoading, setIsLoading] = useState(false);

    // ✅ AGREGAR ESTADOS DE ERRORES
    const [apiError, setApiError] = useState(null);
    const [validationError, setValidationError] = useState(null);
    const [searchInitiated, setSearchInitiated] = useState(false);
    const [reportKey, setReportKey] = useState(Date.now());

    const filtrosRef = useRef(null);
    const procesandoRef = useRef(false);
    const procesandoDatosRef = useRef(false);


    const [loadTimeout, setLoadTimeout] = useState(null);
    const [loadingComponents, setLoadingComponents] = useState(() => ({
        data: { loading: false, progress: 0, complete: false },
        processing: { loading: false, progress: 0, complete: false },
        summary: { loading: false, progress: 0, complete: false },
        map: { loading: false, progress: 0, complete: false },
        velocity: { loading: false, progress: 0, complete: false },
        kilometraje: { loading: false, progress: 0, complete: false },
        visits: { loading: false, progress: 0, complete: false },
        table: { loading: false, progress: 0, complete: false }
    }));

    // ✅ FUNCIÓN PARA LIMPIAR ERRORES
    const clearErrors = useCallback(() => {
        setApiError(null);
        setValidationError(null);
    }, []);


    const [filters, setFilters] = useState({
        fecha_inicio: new Date(new Date().setHours(0, 0, 0, 0)).toISOString(),
        fecha_fin: new Date(new Date().setHours(23, 59, 59, 999)).toISOString(),
        uids_vehiculos: [],
        uids_geocercas: [],
        uids_clientes: [],
        uids_referencias: [],
        uids_choferes: [],
        tipo: "Todo",
        pagina: 0,
        recalculo_geocercas: false,
        //orderByDate:1
    });

    const setFechasFiltros = useRecorridosStore((state) => state.setFechas)
    const setIdVehiculoFiltros = useRecorridosStore((state) => state.setVehiculo)
    const vehiculos = useFiltrosStore((state) => state.vehiculos)


    const isComponentReady = useCallback((component) => {
        if (!loadingComponents || typeof loadingComponents !== 'object' ||
            !loadingComponents.processing || typeof loadingComponents.processing !== 'object' ||
            !loadingComponents.summary || typeof loadingComponents.summary !== 'object' ||
            !loadingComponents.data || typeof loadingComponents.data !== 'object') {
            console.warn('⚠️ isComponentReady: loadingComponents no tiene la estructura esperada:', loadingComponents);
            return false;
        }

        switch (component) {
            case 'map':
                // Ensure resumenUnidad is treated as a boolean expression part
                const mapPrerequisitesMet = recorridos.length > 0 && !!resumenUnidad && Object.keys(resumenUnidad).length > 0;
                return !!(loadingComponents.processing?.complete && mapPrerequisitesMet);
            case 'velocity':
                return !!(loadingComponents.processing?.complete && recorridos.length > 0);
            case 'kilometraje':
                return !!(loadingComponents.processing?.complete && recorridos.length > 0);
            case 'visits':
                // estadias.length can be 0, so >= 0 is correct.
                return !!(loadingComponents.summary?.complete && estadias.length >= 0);
            case 'table':
                return !!(loadingComponents.processing?.complete && recorridos.length > 0);
            default:
                return false;
        }
    }, [loadingComponents, recorridos, resumenUnidad, estadias]); // Depend on actual values, not just length for consistency

    const getComponentProgress = useCallback((component) => {
        if (!loadingComponents || typeof loadingComponents !== 'object' ||
            !loadingComponents.processing || typeof loadingComponents.processing !== 'object' ||
            !loadingComponents.summary || typeof loadingComponents.summary !== 'object') {
            return 0;
        }

        switch (component) {
            case 'map':
            case 'velocity':
            case 'kilometraje':
            case 'table':
                return loadingComponents.processing?.progress || 0;
            case 'visits':
                return loadingComponents.summary?.progress || 0;
            default:
                return 0;
        }
    }, [loadingComponents]);

    const isComponentLoading = useCallback((component) => {
        if (!loadingComponents || typeof loadingComponents !== 'object' ||
            !loadingComponents.processing || typeof loadingComponents.processing !== 'object' ||
            !loadingComponents.summary || typeof loadingComponents.summary !== 'object' ||
            !loadingComponents.data || typeof loadingComponents.data !== 'object') {
            return false;
        }

        switch (component) {
            case 'map':
            case 'velocity':
            case 'kilometraje':
            case 'table':
                return !!(loadingComponents.processing?.loading || loadingComponents.data?.loading);
            case 'visits':
                return !!(loadingComponents.summary?.loading || loadingComponents.processing?.loading); // Assuming processing might affect visits
            default:
                return false;
        }
    }, [loadingComponents]);




    // Actualizar la estructura de debugMetrics para manejar múltiples conexiones:
    const [debugMetrics, setDebugMetrics] = useState({
        searchStartTime: null,
        searchEndTime: null,

        // ✅ CONEXIONES INICIALIZADAS CORRECTAMENTE
        connections: {
            'current-recorridos': {
                name: 'Datos Actuales (GPS)',
                startTime: null,
                endTime: null,
                totalRecordsExpected: 0,
                totalRecordsReceived: 0,
                totalApiCalls: 0,
                completedApiCalls: 0,
                failedApiCalls: 0,
                recoveredApiCalls: 0,
                totalApiCallsMade: 0, // ✅ AGREGAR CAMPO FALTANTE
                apiCallsHistory: [],
                downloadProgress: 0,
                status: 'pending'
            }
        },
        // ✅ MÉTRICAS GLOBALES
        globalTotalRecordsExpected: 0,
        globalTotalRecordsReceived: 0,
        globalDownloadProgress: 0,
        activeConnections: 0,

        // ✅ TIEMPOS DE COMPONENTES
        componentTimes: {
            table: { start: null, end: null },
            vehicles: { start: null, end: null },
            alerts: { start: null, end: null },
            map: { start: null, end: null },
            frequency: { start: null, end: null }
        }
    });

    // ✅ FUNCIÓN updateDebugMetrics CORREGIDA COMPLETA:
    const updateDebugMetrics = useCallback((updates) => {
        setDebugMetrics(prev => {
            if (!prev || !prev.connections) {
                console.warn('⚠️ debugMetrics no está inicializado correctamente');
                return prev || {
                    connections: {},
                    globalTotalRecordsExpected: 0,
                    globalTotalRecordsReceived: 0,
                    globalDownloadProgress: 0,
                    activeConnections: 0,
                    componentTimes: {}
                };
            }

            const newState = { ...prev };

            if (updates.connectionId && newState.connections[updates.connectionId]) {
                const connection = newState.connections[updates.connectionId];

                if (!connection.apiCallsHistory) {
                    connection.apiCallsHistory = [];
                }

                Object.keys(updates).forEach(key => {
                    if (key !== 'connectionId') {
                        if (key === 'apiCallsHistory' && Array.isArray(updates[key])) {
                            const newCalls = updates[key].map(call => ({
                                ...call,
                                timestamp: call.timestamp || Date.now()
                            }));
                            connection[key] = [...(connection[key] || []), ...newCalls];

                            if (connection[key].length > 50) {
                                connection[key] = connection[key].slice(-50);
                            }
                        } else if (key !== 'apiCallsHistory') {
                            connection[key] = updates[key];
                        }
                    }
                });

                const activeConnections = Object.values(newState.connections).filter(conn =>
                    conn && (conn.status === 'downloading' || conn.status === 'completed')
                );

                newState.globalTotalRecordsExpected = activeConnections.reduce((sum, conn) =>
                    sum + (conn.totalRecordsExpected || 0), 0
                );

                newState.globalTotalRecordsReceived = activeConnections.reduce((sum, conn) =>
                    sum + (conn.totalRecordsReceived || 0), 0
                );

                newState.globalDownloadProgress = newState.globalTotalRecordsExpected > 0 ?
                    (newState.globalTotalRecordsReceived / newState.globalTotalRecordsExpected * 100) : 0;

                newState.activeConnections = activeConnections.length;

            } else if (updates.connectionId && !newState.connections[updates.connectionId]) {
                console.warn(`⚠️ Creando conexión ${updates.connectionId} que no existía`);
                newState.connections[updates.connectionId] = {
                    name: updates.connectionId,
                    startTime: null,
                    endTime: null,
                    totalRecordsExpected: 0,
                    totalRecordsReceived: 0,
                    totalApiCalls: 0,
                    completedApiCalls: 0,
                    failedApiCalls: 0,
                    recoveredApiCalls: 0,
                    totalApiCallsMade: 0,
                    apiCallsHistory: [],
                    downloadProgress: 0,
                    status: 'pending'
                };

                Object.keys(updates).forEach(key => {
                    if (key !== 'connectionId') {
                        newState.connections[updates.connectionId][key] = updates[key];
                    }
                });

            } else {
                Object.keys(updates).forEach(key => {
                    if (key === 'componentTimes') {
                        if (!newState.componentTimes) {
                            newState.componentTimes = {};
                        }
                        newState.componentTimes = { ...newState.componentTimes, ...updates.componentTimes };
                    } else if (key !== 'connectionId') {
                        newState[key] = updates[key];
                    }
                });
            }

            return newState;
        });
    }, []);

    const [showDebugPanel, setShowDebugPanel] = useState(false);

    const calculateTotalProgress = useCallback(() => {
        return (debugMetrics.connections?.['current-recorridos']?.downloadProgress) || 0;
    }, [debugMetrics.connections]);


    // ✅ TAMBIÉN CORREGIR updateComponentProgress PARA EVITAR ERRORES
    const updateComponentProgress = useCallback((component, progress, isComplete = false) => {
        setLoadingComponents(prev => {
            if (!prev || typeof prev !== 'object') {
                console.warn('⚠️ loadingComponents estado anterior inválido, reinicializando');
                prev = {
                    data: { loading: false, progress: 0, complete: false },
                    processing: { loading: false, progress: 0, complete: false },
                    summary: { loading: false, progress: 0, complete: false }
                };
            }

            if (!prev[component]) {
                prev[component] = { loading: false, progress: 0, complete: false };
            }

            return {
                ...prev,
                [component]: {
                    loading: !isComplete,
                    progress: progress,
                    complete: isComplete
                }
            };
        });

        // ✅ USAR FUNCIÓN DE CALLBACK PARA debugMetrics
        setDebugMetrics(prevMetrics => {
            if (!prevMetrics || !prevMetrics.componentTimes) {
                return prevMetrics || {
                    componentTimes: {},
                    connections: {},
                    globalTotalRecordsExpected: 0,
                    globalTotalRecordsReceived: 0,
                    globalDownloadProgress: 0,
                    activeConnections: 0
                };
            }

            return {
                ...prevMetrics,
                componentTimes: {
                    ...prevMetrics.componentTimes,
                    [component]: isComplete ?
                        { ...prevMetrics.componentTimes?.[component], end: Date.now() } :
                        { start: Date.now() }
                }
            };
        });
    }, []);

    useEffect(() => {
        if (searchInitiated) {
            if (paginadorRecorridos.cargando) {
                setIsLoading(true);
            } else if (!procesandoDatosRef.current) {
                // Solo desactiva isLoading cuando la carga y el procesamiento estén completos
                setTimeout(() => setIsLoading(false), 200); // Pequeño delay para garantizar visibilidad
            }
        }
    }, [paginadorRecorridos.cargando, searchInitiated]);

    useEffect(() => {
        if (!window.printReportModule) {
            window.printReportModule = new PrintReportModule({
                captureQuality: 0.95,
                pdfFormat: 'A4',
                pdfOrientation: 'landscape',
                useNativeTables: true,
                maxRowsPerPage: 30,
                tableFontSize: 7,
                reportType: 'recorridos',
                horizontalStrategy: 'rows',
                verticalStrategy: 'targets',
                captureTargets: [
                    {
                        title: 'Mapa de Recorridos',
                        selector: '#mapa-recorridos',
                        type: 'card'
                    },
                    {
                        title: 'Gráfica de Velocidad',
                        selector: '#grafica-velocidad',
                        type: 'card'
                    },
                    {
                        title: 'Gráfica de Kilometraje',
                        selector: '#grafica-kilometraje',
                        type: 'card'
                    },
                    {
                        title: 'Visitas Frecuentes',
                        selector: '#visitas-frecuentes',
                        type: 'card'
                    }
                ],
                // ✅ SELECTORES CORREGIDOS ESPECÍFICOS POR CLASES
                horizontalRows: [
                    {
                        selector: '#reporte-content[data-report-area="recorridos"] .row.g-3:first-child',  // MÁS SIMPLE
                        title: 'Mapa y Velocidad',
                        identifier: 'recorridos-fila-1'
                    },
                    {
                        selector: '#reporte-content[data-report-area="recorridos"] .row.g-3.mt-3',
                        title: 'Kilometraje y Visitas Frecuentes',
                        identifier: 'recorridos-fila-2'
                    },
                    {
                        selector: '#reporte-content[data-report-area="recorridos"] .row.mt-3:last-child',  // MÁS SIMPLE
                        title: 'Listado de Recorridos',
                        identifier: 'recorridos-fila-3'
                    }
                ]
            });
        }

        return () => {
            if (window.printReportModule) {
                delete window.printReportModule;
            }
        };
    }, []);

    const handleGenerateReport = useCallback((selectedFilters) => {
        console.log("🚀 Iniciando nueva búsqueda de recorridos");

        procesandoRef.current = false;
        procesandoDatosRef.current = false;
        filtrosRef.current = null;
        datosRef.current = null;

        if (!selectedFilters.uids_vehiculo || selectedFilters.uids_vehiculo.length === 0) {
            setValidationError("Debe seleccionar al menos un vehículo para generar el reporte");
            return;
        }
        if (!selectedFilters.fecha_inicio || !selectedFilters.fecha_fin) {
            setValidationError("Debe seleccionar fechas válidas para el reporte");
            return;
        }
        const fechaInicio = dayjs(selectedFilters.fecha_inicio);
        const fechaFin = dayjs(selectedFilters.fecha_fin);
        const diferenciaDias = fechaFin.diff(fechaInicio, 'day');
        if (diferenciaDias > 31) {
            setValidationError('El rango de fechas no puede ser mayor a 31 días');
            return;
        }
        if (diferenciaDias < 0) {
            setValidationError('La fecha de inicio no puede ser posterior a la fecha de fin');
            return;
        }



        setGeocercas(selectedFilters.geocercas);
        setReferencias(selectedFilters.referencias);
        setClientes(selectedFilters.clientes);
        //console.log(selectedFilters.geocercas);

        console.log("✅ Validaciones completadas, iniciando limpieza...");
        clearErrors();
        setIsLoading(true);
        setSearchInitiated(true);
        setReportKey(Date.now());

        // Reset states that depend on data
        setRecorridos([]);
        setEstadias([]);
        setResumenUnidad({}); // Reset to an empty object, not array, if it's treated as an object

        // Reset loading components to initial state to ensure a clean start for SmartComponentRenderer
        setLoadingComponents({
            data: { loading: false, progress: 0, complete: false },
            processing: { loading: false, progress: 0, complete: false },
            summary: { loading: false, progress: 0, complete: false },
            map: { loading: false, progress: 0, complete: false },
            velocity: { loading: false, progress: 0, complete: false },
            kilometraje: { loading: false, progress: 0, complete: false },
            visits: { loading: false, progress: 0, complete: false },
            table: { loading: false, progress: 0, complete: false }
        });
        // Reset paginador
        paginadorRecorridos.editarDatos([]);
        paginadorRecorridos.editarProgresoCargado(0);
        paginadorRecorridos.editarError(null);

        // 2. RESET DE FLAGS
        procesandoRef.current = false;
        procesandoDatosRef.current = false;
        filtrosRef.current = null;
        datosRef.current = null; // Reset API error state
        // setTotalCarga([]); // This state seems unused or can be derived

        // Reset debugMetrics (ensure this structure is always complete)
        setDebugMetrics({
            searchStartTime: null, searchEndTime: null,
            connections: {
                'current-recorridos': {
                    name: 'Datos Actuales (GPS)', startTime: null, endTime: null,
                    totalRecordsExpected: 0, totalRecordsReceived: 0, totalApiCalls: 0,
                    completedApiCalls: 0, failedApiCalls: 0, recoveredApiCalls: 0,
                    totalApiCallsMade: 0, apiCallsHistory: [], downloadProgress: 0, status: 'pending'
                }
            },
            globalTotalRecordsExpected: 0, globalTotalRecordsReceived: 0,
            globalDownloadProgress: 0, activeConnections: 0,
            componentTimes: { table: {}, vehicles: {}, alerts: {}, map: {}, frequency: {} } // Use empty objects for times
        });

        // Set isLoading to true AFTER other resets, just before triggering data load
        // setIsLoading(true); // This will be set by the data loading useEffect

        try {
            //const filtrosNormalizados = normalizarFiltros(selectedFilters);
            const filtrosNormalizados = {
                ...normalizarFiltros(selectedFilters),
                forceReload: Date.now()
            };
            setFilters(filtrosNormalizados); // This might be redundant if filtrosLocal is the primary driver
            setShowFilters(true); // If this controls UI visibility

            // This will trigger the data loading useEffect
            setFiltrosLocal(filtrosNormalizados);

            // Delay debug metrics update slightly to ensure state propagation
            setTimeout(() => {
                updateDebugMetrics({ searchStartTime: Date.now() });
                console.log("⏱️ Tiempo de inicio registrado");
            }, 0); // Use 0 for next tick

            const _vh = filter(vehiculos, (i) => i.value == (filtrosNormalizados.uids_vehiculo ? filtrosNormalizados.uids_vehiculo[0] : null));
            setFechasFiltros({ fechaInicial: filtrosNormalizados.fecha_inicio, fechaFinal: filtrosNormalizados.fecha_fin });
            if (_vh && _vh.length > 0) {
                setIdVehiculoFiltros({ idVehiculo: _vh[0].id });
            }

        } catch (error) {
            console.error("❌ Error durante la inicialización del reporte:", error);
            setApiError(`Error al inicializar reporte: ${error.message}`);
            setIsLoading(false);
            setSearchInitiated(false);
        }
    }, [
        clearErrors, updateDebugMetrics, vehiculos, setFechasFiltros, setIdVehiculoFiltros,
        paginadorRecorridos, normalizarFiltros
    ]);

    // ✅ EFECTO PARA CARGAR DATOS CON MANEJO DE ERRORES
    useEffect(() => {
        // ✅ EVITAR MÚLTIPLES EJECUCIONES
        if (procesandoRef.current) {
            console.log("⚠️ Ya hay un procesamiento en curso, saltando...");
            return;
        }

        if (paginadorRecorridos.cargando === false &&
            filtrosLocal !== null &&
            (filtrosLocal.uids_vehiculo?.length > 0 || filtrosLocal.uids_vehiculos?.length > 0) &&
            JSON.stringify(filtrosLocal) !== JSON.stringify(filtrosRef.current)) {

            console.log("🚀 Iniciando carga de datos...");
            procesandoRef.current = true;
            filtrosRef.current = { ...filtrosLocal };

            setIsLoading(true);
            updateComponentProgress('data', 10, false);

            const filtrosFormateados = normalizarFiltros(filtrosLocal);
            let connectionId = 'current-recorridos';

            updateDebugMetrics({
                connectionId,
                startTime: Date.now(),
                status: 'downloading'
            });

            const promesaDatosActuales = cargarPaginasUltraOptimizado(
                process.env.REACT_APP_VEHICLE_LOCATIONS_URL,
                paginadorRecorridos,
                filtrosFormateados,
                connectionId,
                null,
                (updates) => {
                    updateDebugMetrics({ ...updates, connectionId });

                    if (updates.downloadProgress) {
                        updateComponentProgress('data', updates.downloadProgress * 0.8, false);
                    }
                }
            );

            promesaDatosActuales.then(() => {
                if (paginadorRecorridos.error) {
                    console.error("❌ Error detectado en paginador de recorridos:", paginadorRecorridos.error);
                    updateComponentProgress('data', 100, true);

                    if (paginadorRecorridos.error.includes('conexión') ||
                        paginadorRecorridos.error.includes('timeout') ||
                        paginadorRecorridos.error.includes('red')) {
                        setApiError(paginadorRecorridos.error);
                    } else {
                        setApiError(`Error en descarga: ${paginadorRecorridos.error}`);
                    }

                    setIsLoading(false);
                    procesandoRef.current = false; // ✅ LIBERAR LOCK
                    return;
                }

                //updateComponentProgress('data', 100, true);

                if (paginadorRecorridos.datos?.length > 0) {
                    const datos = paginadorRecorridos.datos;
                    window.DEBUG_RECORRIDOS_DATA = datos;
                    console.log("📊 Datos de recorridos cargados:", datos.length, "registros");


                }

                updateDebugMetrics({
                    connectionId,
                    endTime: Date.now(),
                    status: 'completed'
                });

                procesandoRef.current = false; // ✅ LIBERAR LOCK

            }).catch(error => {
                console.error("❌ Error en datos de recorridos:", error);
                updateComponentProgress('data', 100, true);

                let errorMessage = error.message || 'Error desconocido en datos de recorridos';

                if (paginadorRecorridos.error) {
                    errorMessage = paginadorRecorridos.error;
                }

                if (errorMessage.includes('conexión') ||
                    errorMessage.includes('timeout') ||
                    errorMessage.includes('red') ||
                    errorMessage.includes('ETIMEDOUT')) {
                    setApiError(errorMessage);
                } else {
                    setApiError(`Error al cargar recorridos: ${errorMessage}`);
                }

                setIsLoading(false);
                procesandoRef.current = false; // ✅ LIBERAR LOCK

                updateDebugMetrics({
                    connectionId,
                    endTime: Date.now(),
                    status: 'failed'
                });
            }).finally(() => {
                procesandoRef.current = false;
                procesandoDatosRef.current = false;
            });
        }
    }, [filtrosLocal?.uids_vehiculo, filtrosLocal?.fecha_inicio, filtrosLocal?.fecha_fin, paginadorRecorridos.cargando]); // ✅ DEPENDENCIAS ESPECÍFICAS

    // ✅ EFECTO PARA MANEJO DE ERRORES DEL PAGINADOR
    useEffect(() => {
        if (paginadorRecorridos.error) {
            console.error("❌ Error en paginador de recorridos:", paginadorRecorridos.error);
            setApiError(paginadorRecorridos.error);
            setIsLoading(false);
        }
    }, [paginadorRecorridos.error]);


    // ✅ FUNCIÓN PARA CONVERTIR FECHA UTC A LOCAL
    const convertirFechaUTCaLocal = (fechaUTC) => {
        if (!fechaUTC) return fechaUTC;

        try {
            let fechaParseada;

            if (fechaUTC.includes('T')) {
                fechaParseada = dayjs.utc(fechaUTC);
            } else if (fechaUTC.includes(' ')) {
                fechaParseada = dayjs.utc(fechaUTC, 'YYYY-MM-DD HH:mm:ss');
            } else {
                fechaParseada = dayjs.utc(fechaUTC);
            }

            const fechaLocal = fechaParseada.local().format('YYYY-MM-DD HH:mm:ss');

            //console.log(`[convertirFecha] UTC: ${fechaUTC} → Local: ${fechaLocal}`);
            return fechaLocal;

        } catch (error) {
            console.warn(`[convertirFecha] Error convirtiendo ${fechaUTC}:`, error);
            return fechaUTC;
        }
    };

    const datosRef = useRef(null);

    useEffect(() => {
        // ✅ EVITAR PROCESAMIENTO MÚLTIPLE
        if (procesandoDatosRef.current) {
            console.log("⚠️ Ya hay procesamiento de datos en curso, saltando...");
            return;
        }

        if (!paginadorRecorridos.datos ||
            !Array.isArray(paginadorRecorridos.datos) ||
            !filtrosLocal ||
            JSON.stringify(paginadorRecorridos.datos) === JSON.stringify(datosRef.current)) {
            //setIsLoading(false);
            return;
        }

        if (paginadorRecorridos.datos.length === 0 && paginadorRecorridos.cargando) {
            return;
        }

        if (paginadorRecorridos.datos.length === 0 && !paginadorRecorridos.cargando) {
            console.log("No se encontraron datos de recorridos para el vehículo seleccionado");
            setRecorridos([]);
            setEstadias([]);
            setResumenUnidad({
                kilometraje_total: 0,
                tiempo_total: 0,
                tiempo_detenido: 0,
                tiempo_movimiento: 0,
                velocidad_maxima: 0,
                velocidad_promedio: 0
            });
            setIsLoading(false);
            updateComponentProgress('processing', 100, true);
            updateComponentProgress('map', 100, true);
            updateComponentProgress('velocity', 100, true);
            updateComponentProgress('kilometraje', 100, true);
            updateComponentProgress('visits', 100, true);
            updateComponentProgress('table', 100, true);
            procesandoDatosRef.current = false;
            return;
        }

        console.log("🔄 Iniciando procesamiento de datos...");
        procesandoDatosRef.current = true;
        datosRef.current = [...paginadorRecorridos.datos];

        try {
            updateComponentProgress('processing', 10, false);

            console.log("Datos originales:", paginadorRecorridos.datos[0]);
            console.log("Total de registros recibidos:", paginadorRecorridos.datos.length);

            updateComponentProgress('processing', 30, false);

            const datosConFechasLocales = paginadorRecorridos.datos.map(item => {
                const fechaLocal = convertirFechaUTCaLocal(item.fecha);

                return {
                    ...item,
                    fecha: fechaLocal,
                    fecha_original_utc: item.fecha
                };
            });

            updateComponentProgress('processing', 50, false);
            console.log(datosConFechasLocales);
            const datosOrdenados = datosConFechasLocales.sort((a, b) => {
                const fechaA = new Date(a.fecha);
                const fechaB = new Date(b.fecha);
                return fechaA.getTime() - fechaB.getTime();
            });

            updateComponentProgress('processing', 70, false);

            const datosRecorridos = procesarRecorridos(datosOrdenados) || [];
            if (datosRecorridos.length === 0) {
                console.warn("procesarRecorridos devolvió un array vacío");
                setIsLoading(false);
                updateComponentProgress('processing', 100, true);
                updateComponentProgress('map', 100, true);
                updateComponentProgress('velocity', 100, true);
                updateComponentProgress('kilometraje', 100, true);
                updateComponentProgress('visits', 100, true);
                updateComponentProgress('table', 100, true);
                procesandoDatosRef.current = false;
                return;
            }

            updateComponentProgress('processing', 85, false);

            const recorridosConVelocidad = asignarVelocidadMaxima(datosRecorridos) || datosRecorridos;

            let recorridosFinales = [...recorridosConVelocidad];

            debugger;
            if (filtrosLocal?.temperatura) {
                const { min, max } = filtrosLocal.temperatura;

                recorridosFinales = recorridosFinales.filter(r => {
                    const temp = parseFloat(r.temperatura);
                    if (isNaN(temp)) return false;

                    if (min !== undefined && max !== undefined) return temp >= min && temp <= max;
                    if (min !== undefined) return temp >= min;
                    if (max !== undefined) return temp <= max;
                    return true;
                });

                console.log("🌡️ Recorridos filtrados por temperatura:", recorridosFinales.length, "registros");
            }

            setRecorridos(recorridosFinales);
            //setRecorridos(datosRecorridos);

            updateComponentProgress('summary', 10, false);

            console.log("🔍 Filtrando recorridos por eventos de motor...");

            console.log('🔍 Ejecutando análisis detallado...');
            const resultadoDebug = debugFiltrarEventosMotor(
                recorridosConVelocidad,
                filtrosLocal.fecha_inicio,
                filtrosLocal.fecha_fin
            );

            const recorridosFiltradosPorMotor = resultadoDebug.recorridosFiltrados;

            // 📊 Mostrar resumen del análisis
            console.log('📊 RESUMEN DEL ANÁLISIS:', resultadoDebug.analisis);

            console.log(`📊 Recorridos después del filtro de motor: ${recorridosFiltradosPorMotor.length} registros`);


            const resumen = calcularResumenUnidad(
                recorridosFiltradosPorMotor,
                filtrosLocal.fecha_inicio,
                filtrosLocal.fecha_fin
            ) || {
                kilometraje_total: 0,
                tiempo_total: 0,
                tiempo_detenido: 0,
                tiempo_movimiento: 0,
                velocidad_maxima: 0,
                velocidad_promedio: 0
            };

            setResumenUnidad(resumen);

            updateComponentProgress('summary', 50, false);

            const filtrosParaEstadias = {
                ...filtrosLocal,
                tipo_reporte: 3,
                tipo_vista: 3,
                tiempo_estancia: Math.max(filtrosLocal.tiempo_estancia || 0, 1)
            };

            const estadiasCalculadas = calcularEstadiasMultiples(datosRecorridos, filtrosParaEstadias) || [];
            setEstadias(estadiasCalculadas.estadias);

            updateComponentProgress('processing', 100, true);
            updateComponentProgress('summary', 100, true);
            updateComponentProgress('map', 100, true);
            updateComponentProgress('velocity', 100, true);
            updateComponentProgress('kilometraje', 100, true);
            updateComponentProgress('visits', 100, true);
            updateComponentProgress('table', 100, true);

            console.log("✅ Procesamiento completado");

        } catch (error) {
            console.error("Error al procesar datos de recorridos:", error);
            setRecorridos([]);
            setEstadias([]);
            setResumenUnidad({
                kilometraje_total: 0,
                tiempo_total: 0,
                tiempo_detenido: 0,
                tiempo_movimiento: 0,
                velocidad_maxima: 0,
                velocidad_promedio: 0
            });

            setApiError(`Error al procesar datos: ${error.message}`);
            setIsLoading(false);
        } finally {
            //setIsLoading(false);
            procesandoDatosRef.current = false;
        }
    }, [paginadorRecorridos.datos?.length, paginadorRecorridos.cargando, filtrosLocal?.uids_vehiculo]);
    // ✅ CLEANUP AL DESMONTAR
    useEffect(() => {
        return () => {
            procesandoRef.current = false;
            procesandoDatosRef.current = false;
        };
    }, []);

    const MySwal = withReactContent(Swal);

    // ✅ FUNCIÓN PARA DETERMINAR QUÉ ESTADO MOSTRAR
    const shouldShowEmptyState = useCallback(() => {
        if (isLoading) return false;

        // ✅ VERIFICACIÓN MÁS ROBUSTA
        if (!filtrosLocal ||
            !Array.isArray(filtrosLocal.uids_vehiculo) ||
            filtrosLocal.uids_vehiculo.length === 0) {
            return true;
        }

        if (recorridos.length === 0 && !paginadorRecorridos.cargando) {
            return true;
        }

        return false;
    }, [isLoading, filtrosLocal, recorridos.length, paginadorRecorridos.cargando]);

    const getEmptyStateProps = useCallback(() => {
        // ✅ VERIFICACIÓN MÁS ROBUSTA
        if (!filtrosLocal ||
            !Array.isArray(filtrosLocal.uids_vehiculo) ||
            filtrosLocal.uids_vehiculo.length === 0) {
            return {
                component: <NoSelectionEmptyState reportType="temperatura" entityType="temperatura" />,
                show: true
            };
        }

        return {
            component: <NoDataEmptyState reportType="temperatura" entityType="temperatura" />,
            show: true
        };
    }, [filtrosLocal]);

    const [filterType, setFilterType] = useState("0");
    const [recorridosFiltrados, setRecorridosFiltrados] = useState([]);

    useEffect(() => {

        if (filterType.startsWith("¬")) {
            console.log(filterType);
            //Busqueda por nombre exacto en sus propiedad
            const nombreFiltro = filterType.substring(1);
            const nuevosRecorridos = recorridos.filter(r =>
                r.geocercas_concat.includes(nombreFiltro) ||
                r.clientes_concat.includes(nombreFiltro) ||
                r.referencias_concat.includes(nombreFiltro)
            );
            setRecorridosFiltrados(nuevosRecorridos.map((r) => {
                let vehiculo = vehiculos.filter(w => w.value === r.uid_vehiculo);
                return ({ ...r, color: vehiculo.length > 0 ? vehiculo[0].color_vehiculo : '#000000' });
            }));
        }
        else {

            setRecorridosFiltrados(recorridos.map((r) => {
                let vehiculo = vehiculos.filter(w => w.value === r.uid_vehiculo);
                return ({ ...r, color: vehiculo.length > 0 ? vehiculo[0].color_vehiculo : '#000000' });
            }));
        }




    }, [filterType, recorridos]);

    const tableContainer = document.querySelector('#tabla-recorridos');
    if (tableContainer) {
        console.log('📍 Contenedor encontrado:', tableContainer);

        const table = tableContainer.querySelector('table');
        console.log('📊 Tabla encontrada:', table);

        if (table) {
            const headers = table.querySelectorAll('thead th, thead td');
            const rows = table.querySelectorAll('tbody tr');

            console.log('Headers:', Array.from(headers).map(h => h.textContent.trim()));
            console.log('Filas:', rows.length);
            console.log('Primera fila:', Array.from(rows[0]?.querySelectorAll('td') || []).map(td => td.textContent.trim()));
        }
    } else {
        console.error('❌ No se encontró contenedor #tabla-recorridos');
    }


    return (
        <GoogleMapsProvider>

            <div className=" m-3 ">
                <Row >
                    <Col md={10}>
                        <h4 className="mt-2">Temperatura</h4>
                    </Col>
                </Row>
            </div>

            <Card className="p-3 mb-3 mt-3">

                {/* Encabezado y filtros (sin cambios) */}
                <hr className="text-danger" />

                <Filtros onGenerateReport={handleGenerateReport}
                    disabled={isLoading} imprimir={!searchInitiated ? (false) : isLoading ? (false) : shouldShowEmptyState() ? (false) :
                        (true)} />

                {/* ✅ MOSTRAR ERRORES DE VALIDACIÓN */}
                {validationError && (
                    <ValidationError
                        message={validationError}
                        onDismiss={() => setValidationError(null)}
                    />
                )}

                {/* ✅ MOSTRAR ERRORES DE API */}
                {apiError && (
                    <APIError
                        message={apiError}
                        onDismiss={() => setApiError(null)}
                    />
                )}


                {paginadorRecorridos.cargando && (
                    <Col md={12}>
                        <ProgressBarWithRealTimeMetrics
                            debugMetrics={debugMetrics}
                            loadingComponents={loadingComponents} // ✅ USAR loadingComponents REAL
                            calculateTotalProgress={calculateTotalProgress} // ✅ AGREGAR FUNCIÓN FALTANTE
                            showTitle={true}
                            title="Generando reporte de recorridos..."
                        />
                    </Col>
                )}

            </Card>

            {!searchInitiated ? (
                // Estado inicial - no se ha iniciado búsqueda
                <WelcomeEmptyState reportType="temperatura" />
            ) : isLoading ? (
                // Estado de carga 
                <LoadingEmptyState reportType="temperatura" />
            ) : shouldShowEmptyState() ? (
                // Estados de error o sin datos
                getEmptyStateProps().component
            ) :
                (// Hay datos, mostrar el reporte completo            

                    <div id="reporte-content" data-report-area="recorridos">
                        <React.Fragment key={reportKey}>


                            <Row className="g-3">
                                <Col md={12} xs={12}>
                                    <div id="grafica-velocidad" style={{ height: '450px' }}>
                                        <SmartComponentRenderer
                                            component="velocity"
                                            title="Gráfica de Velocidad"
                                            priority={2}
                                            data={recorridos}
                                            skeletonType="chart"
                                            chunkSize={25}
                                            enableProgressive={false}
                                            loadingState={loadingComponents.velocity}
                                        >
                                            <AnimatedComponentWrapper>
                                                <Temperatura data={recorridos} />
                                            </AnimatedComponentWrapper>
                                        </SmartComponentRenderer>
                                    </div>
                                </Col>
                            </Row>

                            <Row className="mt-3">
                                <Col md={12} xs={12}>
                                    <div id="tabla-recorridos" style={{ height: '620px' }}>
                                        <SmartComponentRenderer
                                            component="table"
                                            title="Listado de Recorridos"
                                            priority={5}
                                            data={recorridos}
                                            skeletonType="table"
                                            chunkSize={25}
                                            enableProgressive={false}
                                            loadingState={loadingComponents.table}
                                        >
                                            <AnimatedComponentWrapper>
                                                <RecorridosTableList
                                                    data={recorridosFiltrados}
                                                    geocercas={geocercas || []}
                                                    referencias={referencias || []}
                                                    clientes={clientes || []}
                                                    title={"Listado Temperatura"}
                                                    isGroup={true}
                                                />
                                            </AnimatedComponentWrapper>
                                        </SmartComponentRenderer>
                                    </div>
                                </Col>
                            </Row>

                        </React.Fragment>
                    </div>

                )}

        </GoogleMapsProvider>
    );
}

